class StopService {
  stopWithoutRoute = null;

  updateSelectedStops = (stopId, selectedStops, stops) => {
    const stopsToOptimize = { ...selectedStops };
    const stop = stops.find(item => item.id == stopId);

    if (!this.stopWithoutRoute) {
      this.stopWithoutRoute = stopId;
      stopsToOptimize[stopId] = {
        prevRoute: stop['route_id'],
        address: stop['address'],
        nextRoute: null,
      };
    } else if (this.stopWithoutRoute === stopId) {
      delete stopsToOptimize[stopId];
      this.stopWithoutRoute = null;
    } else if (stopsToOptimize[stopId] && stopsToOptimize[stopId].nextRoute) {
      stopsToOptimize[this.stopWithoutRoute].nextRoute =
        stopsToOptimize[stopId].nextRoute;
      delete stopsToOptimize[stopId];
    } else if (
      stopsToOptimize[this.stopWithoutRoute] && stopsToOptimize[this.stopWithoutRoute].prevRoute == stop['route_id']
    ) {
      delete stopsToOptimize[this.stopWithoutRoute];
      this.stopWithoutRoute = null;
    } else {
      stopsToOptimize[this.stopWithoutRoute].nextRoute = stop['route_id'];
      this.stopWithoutRoute = null;
    }

    return stopsToOptimize;
  };

  removeStop = (stopId, stopsToOptimize) => {
    const newSet = {...stopsToOptimize};
    delete newSet[stopId];
    this.stopWithoutRoute = null;
    return newSet;
  };

  isNewStopAdded = () => !!this.stopWithoutRoute;
}
export default new StopService();
